import { useState, useCallback, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useUserStore } from '../../../store/useUserStore';
import Url from '../../../data/url';
import { VIDEO_RECORD_TYPE } from '../../../data/define';
import ImgDolphin from '../../../assets/image/img_video_home.png';
import ImgHorse from '../../../assets/image/img_video_home2.png';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import BottomFixedBtn from '../../../component/common/BottomFixedBtn';
import RecordingGuideDialog from '../../../component/register/RecordingGuideDialog';
import UploadVideoCautionDialog from '../../../component/register/UplodaVideoCautionDialog';
import IntelligenceChoiceDialog from '../../../component/register/IntelligencChoiceDialog';
import VideoHandleDialog from '../../../component/register/VideoHandleDialog';
import { useTranslation } from '../../../hook/useTranslation';

export default function UploadVideo() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const location = useLocation();
  const state = location.state as {
    kidId: number;
    mi?: number[];
    isCautionOpen?: boolean;
    reportId?: number;
    replaced?: boolean;
  } | null;
  const user = useUserStore();
  const [guideOpen, setGuideOpen] = useState(false);
  const [cautionOpen, setCautionOpen] = useState(false);
  const [intelligenceChoiceOpen, setIntelligenceChoiceOpen] = useState(false); // 영상문답(type:2)시 오픈
  const [intelligences, setIntelligences] = useState<number[]>([]); // 영상문답에서 선택한 지능들
  const [btnChoiceOpen, setBtnChoiceOpen] = useState(false);
  const isDailyType =
    type === null || (type !== null && Number(type) === VIDEO_RECORD_TYPE.DAILY) ? true : false; // true: 일상 영상, false: 영상 문답

  const handleOpenGuide = useCallback(() => {
    if (isDailyType) {
      setCautionOpen(false);
      setBtnChoiceOpen(true);
    } else {
      setCautionOpen(false);
      setIntelligenceChoiceOpen(true);
    }
  }, [isDailyType]);

  const handleIntelligenceChoice = useCallback(() => {
    setIntelligenceChoiceOpen(false);
    setBtnChoiceOpen(true);
  }, []);

  useEffect(() => {
    if (state?.isCautionOpen === true) {
      setCautionOpen(true);
    }
  }, [state?.isCautionOpen]);

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev
        title={isDailyType ? t('register_kids.upload.daily_title') : t('register_kids.upload.qna_title')}
        onClickPrev={() => navigate((state?.replaced ? Url.Home : -1) as any)}
        style={{ backgroundColor: isDailyType ? '#FFFEF5' : '#FFF5F9' }}
      />
      {user?.isSignup && (
        <button
          type="button"
          className="absolute top-3 right-4 text-[#969696] text-[14px] underline"
          onClick={() => navigate(Url.LoginWelcome)}
          style={{ color: '#969696' }}
        >
          {t('register_kids.upload.skip')}
        </button>
      )}
      <div
        className="pageInner bg-[#FFFEF5]"
        style={{
          backgroundColor: isDailyType ? '#FFFEF5' : '#FFF5F9',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div className="relative w-full h-full flex flex-col items-center justify-center">
          <div className="w-full absolute z-1 top-0 left-0 flex flex-col items-center justify-center gap-2 ">
            <div className="text-[28px] font-[800] text-['Pretendard']">
              {isDailyType ? (
                <>
                  {t('register_kids.upload.daily_main_title').split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      {i === 0 && <br />}
                    </span>
                  ))}
                </>
              ) : (
                <>
                  {t('register_kids.upload.qna_main_title').split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      {i === 0 && <br />}
                    </span>
                  ))}
                </>
              )}
            </div>
            <div className="text-[#363636] text-[14px] font-[400]">
              {isDailyType
                ? t('register_kids.upload.daily_sub_title')
                : t('register_kids.upload.qna_sub_title')}
            </div>
          </div>
          <div
            className="relative flex flex-col items-center justify-center gap-2 h-full mt-10"
            style={{ width: '100dvw' }}
          >
            <img
              src={isDailyType ? ImgDolphin : ImgHorse}
              alt="mainImage"
              className="w-full h-full"
              style={{
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
        {isDailyType && (
          <button
            type="button"
            className="absolute bottom-0 right-0 left-0 text-[#363636] text-[14px] font-[400] underline"
            onClick={() => setGuideOpen(true)}
          >
            {t('register_kids.upload.guide_btn')}
          </button>
        )}
        <RecordingGuideDialog
          open={guideOpen}
          onClose={() => setGuideOpen(false)}
          onConfirm={() => setGuideOpen(false)}
        />
        <UploadVideoCautionDialog
          open={cautionOpen}
          onClose={() => setCautionOpen(false)}
          onConfirm={handleOpenGuide}
        />
        <IntelligenceChoiceDialog
          open={intelligenceChoiceOpen}
          onClose={() => setIntelligenceChoiceOpen(false)}
          intelligences={intelligences}
          setIntelligences={setIntelligences}
          handleConfirm={handleIntelligenceChoice}
        />
        <VideoHandleDialog
          type={type}
          open={btnChoiceOpen}
          onClose={() => {
            setBtnChoiceOpen(false);
          }}
          kidId={state?.kidId}
          mi={isDailyType ? state?.mi : intelligences}
          reportId={state?.reportId}
          setCautionOpen={setCautionOpen}
        />
      </div>
      <BottomFixedBtn
        title={t('register_kids.upload.btn_upload')}
        onClick={() => setCautionOpen(true)}
        style={{ backgroundColor: isDailyType ? '#FFFEF5' : '#FFF5F9' }}
      />
    </FullHeightContainer>
  );
}
